import { TimeSlotWithSearch } from "@/components/shared/time-slot-with-search";
import { Button, View } from "@/components/ui";
import type { RescheduleVisitContentProps } from "..";
import { InfoDialog } from "@/components/shared/info-dialog";
import { ChooseWorkerModal } from "@/components/shared/booking/choose-worker-modal";
import { SuitableWorkerModal } from "../../suitable-worker-modal";
import { Message } from "@/components/shared/message";
import { Column, Container } from "@/components/ui/layout";
import { RescheduleVisitInfo } from "../../reschedule-visit-info";
import { IconButton } from "@/components/ui/icon-button";
import { Typography } from "@/components/shared/typography";
import { useRoute } from "@/components/shared/router";
import { useWindowDimensions } from "@/components/hooks/use-window-dimension";
import { useComponentHeight } from "@/components/hooks/use-component-height";
import { MAX_MOBILE_WIDTH } from "@/constants";

export function RescheduleVisitContentScreen({
  timeSlotProps,
  onConfirm,
  disabledButton,
  chooseWorkerDepartment,
  handleApply,
  infoDialogSuccess,
  onCloseInfoDialog,
  onCloseOpenSuitableWorker,
  openChooseWorker,
  openSuitableWorker,
  selectedWorkers,
  setOpenChooseWorker,
  visitWorker,
}: RescheduleVisitContentProps) {
  const {
    name,
    initialStartDate,
    department,
    endDate,
    loading,
    onChooseWorkers,
    onClickWorkerPortfolio,
    onSelectSlot,
    selectedSlot,
    setEndDate,
    setStartDate,
    startDate,
    timeSlots,
    workerLabel,
    workersIds,
    hidePricing,
  } = timeSlotProps;

  const { pull } = useRoute();

  const { width } = useWindowDimensions();

  const isDesktop = width >= MAX_MOBILE_WIDTH;

  const { height, ref } = useComponentHeight();

  return (
    <Container gap="xl">
      <Column desktop="8">
        <View>
          <View className="flex flex-row items-center gap-1.5">
            <IconButton
              variant="ghost"
              color="CTA2"
              iconName="arrowLeft"
              onClick={pull}
            />
            <Typography variant="label-lg" className="my-4">
              Available Time Slot
            </Typography>
          </View>
        </View>
        <View
          className="flex flex-col gap-2 md:gap-6"
          style={{ paddingBottom: height + 24 }}
        >
          <TimeSlotWithSearch
            name={name}
            initialStartDate={initialStartDate}
            department={department}
            showTimeRange
            loading={loading}
            selectedSlot={selectedSlot}
            timeSlots={timeSlots}
            workersIds={workersIds}
            workerLabel={workerLabel}
            startDate={startDate}
            endDate={endDate}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            enableChooseWorker
            onChooseWorkers={onChooseWorkers}
            onSelectSlot={onSelectSlot}
            onClickWorkerPortfolio={onClickWorkerPortfolio}
            hidePricing={hidePricing}
          />
          {hidePricing && (
            <Message
              variant="info"
              message="You will be charged at the rate from your original booking, not the rate of the new slot."
            />
          )}
          <View
            ref={ref}
            className="fixed bottom-0 flex w-full flex-col gap-2 self-end border-t bg-white p-4 md:static md:gap-6 md:border-t-0 md:p-0"
          >
            {!isDesktop && <RescheduleVisitInfo />}
            <Button
              variant="primary"
              color="CTA"
              loading={loading}
              fullWidth="full"
              onClick={onConfirm}
              disabled={disabledButton}
              children="Reschedule"
            />
          </View>
          <InfoDialog
            open={infoDialogSuccess}
            title="Success"
            subtitle="Your visit schedule has been updated"
            onConfirm={onCloseInfoDialog}
          />
          <ChooseWorkerModal
            department={chooseWorkerDepartment}
            open={openChooseWorker}
            workerLabel={workerLabel}
            setOpen={setOpenChooseWorker}
            selectedWorkers={selectedWorkers}
            handleApply={handleApply}
            visitWorker={visitWorker}
          />
          <SuitableWorkerModal
            open={openSuitableWorker}
            onClose={onCloseOpenSuitableWorker}
          />
        </View>
      </Column>
      {isDesktop && (
        <Column desktop="4">
          <View className="p-4 md:my-10">
            <RescheduleVisitInfo />
          </View>
        </Column>
      )}
    </Container>
  );
}
